<template>
	<div class="row">
		<div class="col-sm-5 col-md-5">
			<h3>My account</h3>
			<hr>
			<div class="row">
				<app-account-card v-if="myAccount.accountId" :account="myAccount"></app-account-card>
			</div>
<!--			<div class="row">-->
<!--				<button type="submit" class="btn btn-primary" @click.prevent="associateToken">Associate Token-->
<!--				</button>-->
<!--			</div>-->
		</div>
		<div class="col-sm-5 col-sm-offset-1">
			<h3>My token</h3>
			<hr>
			<app-token-list :is-admin="false" :account="myAccount" :tokens="tokens"></app-token-list>
		</div>
	</div>
</template>

<script>
	import AccountCard from "@/components/account/AccountCard";

	import { EventBus } from "@/eventBus";
	import { PrivateKey } from "@hashgraph/sdk";
	import { tokenAssociate, tokenCreate } from "@/service/tokenService";
	import TokenList from "@/components/token/TokenList";
	import { accountGetInfo } from "@/service/accountInfo";

	export default {
		data() {
			return {
				token: {},
				tokenRelationships: {}
			}
		},
		computed: {
			myAccount() {
				return this.$store.getters.getCurrentAccount;
			},
			tokens() {
				return this.tokenRelationships;
			}
		},
		components: {
			appAccountCard: AccountCard,
			appTokenList: TokenList
		},
		methods: {
			async getTokens() {
				const resultTokens = [];
				this.tokenRelationships = {}
				const tokenRelationships = await accountGetInfo(this.myAccount.accountId);
				for (const key in tokenRelationships) {
					const tokenRelationship = tokenRelationships[key];
					resultTokens.push(tokenRelationship);
				}
				this.tokenRelationships = resultTokens;
			}
		},
		created() {
			if(!this.$store.getters.isLoggedIn) {
				this.$router.push({name: 'login'});
			}
			this.getTokens();
			EventBus.$on('updateTokenStatus', result => {
				console.log('event updateTokenStatus on : ' + result);
				if(result) {
					this.getTokens();
				}
			});
		}
	}
</script>

<style scoped>

</style>